var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpoadBgGrayIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_161016",
    "data-name": "Group 161016",
    transform: "translate(-493.633 -396.25)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_286",
    "data-name": "Ellipse 286",
    cx: 16,
    cy: 16,
    r: 16,
    transform: "translate(493.633 396.25)",
    fill: "#e8e8e8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "upload-minimalistic-svgrepo-com",
    transform: "translate(500.453 402.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2360",
    "data-name": "Path 2360",
    d: "M11.051,2.425a.537.537,0,0,0-.793,0L7.391,5.56a.538.538,0,0,0,.793.725l1.933-2.114V12.1a.538.538,0,1,0,1.075,0V4.172l1.933,2.114a.537.537,0,1,0,.793-.725Z",
    transform: "translate(-1.417)",
    fill: "#3b3b3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2361",
    "data-name": "Path 2361",
    d: "M3.325,14.788a.538.538,0,1,0-1.075,0v.039a19.65,19.65,0,0,0,.084,2.391,2.664,2.664,0,0,0,.7,1.62,2.664,2.664,0,0,0,1.62.7,19.661,19.661,0,0,0,2.391.083h4.379a19.662,19.662,0,0,0,2.391-.083,2.664,2.664,0,0,0,1.62-.7,2.664,2.664,0,0,0,.7-1.62,19.662,19.662,0,0,0,.083-2.391v-.039a.538.538,0,1,0-1.075,0,19.264,19.264,0,0,1-.074,2.288,1.616,1.616,0,0,1-.4,1,1.616,1.616,0,0,1-1,.4,19.263,19.263,0,0,1-2.288.074h-4.3A19.262,19.262,0,0,1,4.8,18.476a1.616,1.616,0,0,1-1-.4,1.616,1.616,0,0,1-.4-1A19.252,19.252,0,0,1,3.325,14.788Z",
    transform: "translate(0 -3.4)",
    fill: "#3b3b3b"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpoadBgGrayIcon);
export default __webpack_public_path__ + "static/media/upoad-bg-gray-icon.20e2aa0ddb268a61dbde8842b3ff0db0.svg";
export { ForwardRef as ReactComponent };